import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace("#", ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/emergent/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(data);
        // Strip hash and go to dashboard
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate(data.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-rooftop)]">
      <div className="text-sm text-[var(--text-muted)]" data-testid="auth-callback-loading">SONARA · Authentifizierung…</div>
    </div>
  );
}
